import { useState } from "react";
import AgeVerification from "./components/AgeVerification";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import SessionSection from "./components/SessionSection";
import PriceSection from "./components/PriceSection";
import ScheduleSection from "./components/ScheduleSection";
import HowToBookSection from "./components/HowToBookSection";
import GallerySection from "./components/GallerySection";
import VideoSection from "./components/VideoSection";
import ReviewsSection from "./components/ReviewsSection";
import BlogSNSSection from "./components/BlogSNSSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  const [verified, setVerified] = useState(() => {
    return sessionStorage.getItem("age_verified") === "true";
  });

  return (
    <>
      <AgeVerification onVerified={() => setVerified(true)} />
      {verified && (
        <div className="min-h-screen bg-white flex flex-col">
          <Navbar />
          <main className="flex-1">
            <HeroSection />
            <AboutSection />
            <SessionSection />
            <PriceSection />
            <ScheduleSection />
            <HowToBookSection />
            <GallerySection />
            <VideoSection />
            <ReviewsSection />
            <BlogSNSSection />
            <ContactSection />
          </main>
          <FooterSection />
        </div>
      )}
    </>
  );
}
